class Search {
    constructor() {
        this.searchbar = $('#navsearch');
        this.input = $('#navsearch-input');
        this.clearSearchField = $('#clearSearchField');
        this.nav = $('.nav__list');
        this.resultNavItem = $('.result-nav__item');
        this.resultLink = $('.result-nav__link');
        this.resultsBox = $('.search-result');
        this.events();
        this.mobileAccordion();
    }

    events() {
        const _this = this;

        $(document).click(e => {
            if ($(e.target).is('.icon-search') || $(e.target).parent().hasClass('.mobile-search')) {
                e.preventDefault();
                if (!this.isSearchActive()) {
                    this.openSearch();
                } else {
                    this.closeSearch();
                }
            } else {
                this.closeSearch();
            }

        }).on('keyup keydown', e => {
            if (e.key === 'Escape' && this.isSearchActive()) {
                this.closeSearch();
            }
        });


        //close searchbar when clicked out of search bar
        this.searchbar.click(e => {
            if ($(e.target).hasClass('result-nav__link')) return
            e.stopPropagation();
        })

        //clear input field
        this.clearSearchField.click(e => {
            e.preventDefault();
            this.input.val('');
            this.clearSearchField.fadeOut();
            this.resultsBox.html('');
        }).bind(this);


        //show clear button if when start writing on input
        this.input.on('keyup keypress keydown', e => {
            var inputValue = $(e.target).val();
            if (inputValue.length > 0) {
                $(_this.clearSearchField).fadeIn();
            } else {
                $(_this.clearSearchField).fadeOut();
            }
        })

        var searchTimeoutThrottle = 500;
        var searchTimeoutID = -1;
        var currReqObj = null;

        this.input.on('keyup', function (){
            // Kill outstanding ajax request
            if(currReqObj != null) currReqObj.abort();
            // Kill previous search
            clearTimeout(searchTimeoutID);

            var val = $(this).val();
            if (val.length <= 0) {
                _this.resultsBox.html('');
                return false;
            }

            //Search term
            var term = '*' + val + '*';

            // Do next search (in X milliseconds)
            searchTimeoutID = setTimeout(function(){
                //Ajax hit on search page
                currReqObj = $.ajax({
                    url: '/search',
                    data: {
                        view: 'ajax',
                        q: term
                    },
                    success: function(data){
                        _this.resultsBox.html(data)
                    }
                });
            }, searchTimeoutThrottle);
        })

    }

    //open search field
    openSearch() {
        if ($(window).width() >= 768) {
            this.searchbar.addClass('open');
        } else {
            this.nav.slideUp();
            $('body').removeClass('navOpen');
            this.searchbar.addClass('open');
            this.searchbar.slideDown();
        }
        setTimeout(() => {
            this.input.focus();
        }, 100)
    }

    //close search field
    closeSearch() {
        if ($(window).width() >= 768) {
            this.searchbar.removeClass('open');
        } else {
            this.searchbar.removeClass('open');
            this.searchbar.slideUp();
        }
        setTimeout(() => {
            this.input.val('')
        }, 100)
    }


    //check if search bar is active;
    isSearchActive() {
        return this.searchbar.hasClass('open');
    }

    mobileAccordion() {
        const $global = this;

        $('body').on('click', '.result-nav__link', function (e) {
            if ($(this).parent().hasClass('open')) {
                $(this).parent().removeClass('open').find('.result-menu').slideUp();
            } else {
                $global.resultNavItem.removeClass('open').find('.result-menu').slideUp();
                $(this).parent().addClass('open').find('.result-menu').slideDown();
            }

            e.stopPropagation();
        })
    }


}

export default Search;
